import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';
import { addressesEntityAdapter } from './addressesEntityAdapters';

export const addressesSelectors = addressesEntityAdapter.getSelectors<RootState>(state => state.addresses);

export const getDefaultAddresses = createSelector(addressesSelectors.selectAll, addresses =>
  addresses.filter(x => x.axRecId)
);
